// extracted by mini-css-extract-plugin
module.exports = {"container":"Subscribe_container__1Uy63","title":"Subscribe_title__GMLbP","pointer":"Subscribe_pointer__3_oAg","qrcode":"Subscribe_qrcode__15V_R"};